import { __decorate, __metadata } from "tslib";
import { IdItemModel, Expose, ItemModelProp, EditorDefinition, CrudEndpoints, ItemModelDefinition, ModelId, AllowHtml, IsString } from '@core/shared/model';
import { UseRestraints } from '@core/shared/restraints';
import { MediaAssetSubtitlesRestraints } from "./media-asset-subtitles.restraints";
import { MediaAssetItem } from './media-asset.item';
// 
let MediaAssetSubtitlesItem = /*#__PURE__*/(() => {
  let MediaAssetSubtitlesItem = class MediaAssetSubtitlesItem extends IdItemModel {
    toString() {
      return "MediaAssetSubtitles " + this.name;
    }
  };
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: true
  }), __metadata("design:type", Boolean)], MediaAssetSubtitlesItem.prototype, "enabled", void 0);
  __decorate([Expose(), __metadata("design:type", String)], MediaAssetSubtitlesItem.prototype, "lang", void 0);
  __decorate([Expose(), IsString(), AllowHtml({
    skipProcessing: true
  }) // webVTT can contain xml-like tags as well as --> arrows in timecodes! Must NOT be processed by SafeHtmlGuard!
  , __metadata("design:type", String)], MediaAssetSubtitlesItem.prototype, "data", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], MediaAssetSubtitlesItem.prototype, "assetId", void 0);
  __decorate([Expose(), __metadata("design:type", MediaAssetItem)], MediaAssetSubtitlesItem.prototype, "asset", void 0);
  MediaAssetSubtitlesItem = __decorate([EditorDefinition({}, {
    allowAllExposed: true,
    useCrudEndpoint: 'admin'
  }), CrudEndpoints({
    admin: '/admin/media/asset-subtitles'
  }), ItemModelDefinition({
    texts: {}
  }), UseRestraints(MediaAssetSubtitlesRestraints), ModelId("MediaAssetSubtitlesItem") // autogenerated by generate-model-ids
  ], MediaAssetSubtitlesItem);
  return MediaAssetSubtitlesItem;
})();
export { MediaAssetSubtitlesItem };